import { render } from "./RightDrawer.vue?vue&type=template&id=892f3e1e&scoped=true"
import script from "./RightDrawer.vue?vue&type=script&lang=js"
export * from "./RightDrawer.vue?vue&type=script&lang=js"

import "./RightDrawer.vue?vue&type=style&index=0&id=892f3e1e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-892f3e1e"]])

export default __exports__